<template>
  <div id="wrapper">
    <nav>
      <!-- Header -->
      <Header></Header>
    </nav>
    <!-- Body -->
    <div class="content"> 
      <router-view/>
    </div>
    <!-- Footer -->
    <div class="footer">
      <div class="copyright">
        <div class="wrapper">
          <p>&copy; 2022-2028 - HUASTRADE</p>
          <p>ICP证书:
            <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">浙ICP备19049254号-3</a>
          </p>
        </div>
      </div>
  </div>
  </div>
</template>

<style>
  @import './assets/font/font.css';
  html,body,#app {
    font-family: 'Gantari','Avenir', 'Helvetica', 'Arial', 'sans-serif';
    font-weight: 400;
    height: 100%;
    background-color: whitesmoke;  /* adjust the color of the whole canvas througout all pages */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

body .footer {
    background: #2e3034;
}
body .footer .copyright {
    height: 34px;
    font-family: -apple-system,BlinkMacSystemFont,Arial,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    font-size: 11px;
    color: #a4a5a9;
    letter-spacing: .88px;
    text-align: center;
    line-height: 18px;
    border-top: 1px solid #434549;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
}


body {
    background: var(--huas-page-bg-color);
    font-size: var(--huas-font-size-base);
    font-family: -apple-system,BlinkMacSystemFont,arial,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

article, aside, blockquote, body, button, code, dd, details, div, dl, dt, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, hr, input, legend, li, menu, nav, ol, p, pre, section, td, textarea, th, ul {
    margin: 0;
    padding: 0;
}

body {
    margin: 0;
}

article, aside, blockquote, body, button, dd, details, div, dl, dt, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, hr, input, legend, li, menu, nav, ol, p, section, td, textarea, th, ul {
    margin: 0;
    padding: 0;
}
body {
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",Arial,sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #515a6e;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
body {
    margin: 0;
}

* {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
用户代理样式表
body {
    display: block;
    margin: 8px;
}

*, ::after, ::before {
    box-sizing: border-box;
}
div {
    display: block;
}
.huas-container {
    overflow: visible;
    width: var(--huas-main-container-width);
    margin: 0 auto;
}
.condition.sort {
    border-bottom: 1px dashed #e9e9e9;
}

.condition {
    display: flex;
}
.condition.search {
    margin-top: 16px;
}
.condition.sort .condition-label {
    line-height: 22px;
}

.condition-label {
    width: 66px;
    flex-shrink: 0;
}

.condition.sort .condition-input {
    display: flex;
    flex-flow: row wrap;
}

.condition-input {
    flex-grow: 1;
}

.sort-indicator.active, .sort-indicator:hover {
    background: #e74c3c;
}

.sort-indicator {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 2px;
    padding: 4px 7px;
    margin-bottom: 16px;
    margin-right: 24px;
}

.sort-indicator.active .huas-icon-info, .sort-indicator.active .sort-indicator-title, .sort-indicator:hover .huas-icon-info, .sort-indicator:hover .sort-indicator-title {
    color: #fff;
}

.sort-indicator-title {
    color: var(--huas-font-color-base);
}



.content{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  /* margin: 16px 0 10px; */
}

body .footer .copyright {
    height: 34px;
    font-family: -apple-system,BlinkMacSystemFont,Arial,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    font-size: 11px;
    color: #a4a5a9;
    letter-spacing: .88px;
    text-align: center;
    line-height: 18px;
    border-top: 1px solid #434549;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
}
body {
    background-color: #fff;
    font-size: 15px;
    font-family: -apple-system,BlinkMacSystemFont,arial,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
body {
    margin: 0;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}

</style>

<script>
import Header from "@/components/Header2.vue"

export default {
  name: "Layout",
  components: {
    Header
  }
}
</script>
